import { createAction } from '@reduxjs/toolkit';
import EcomEngineAPI from 'api/ecom_engine_api';
import { trackError } from 'utils/helpers';
import { discardBooking } from '../booking';

const createReservationStarted = createAction(
  'reservation/createReservationStarted'
);
const createReservationSucceeded = createAction(
  'reservation/createReservationSucceeded'
);
const createReservationFailure = createAction(
  'reservation/createReservationFailure'
);

const createReservation =
  ({
    resource_id,
    first_travel_date,
    passenger_types,
    extra_pick_ids,
    bed_requirement_id,
    include_product_page_id = true,
    discard_existing = true,
  }) =>
  (dispatch, getState) => {
    dispatch(createReservationStarted());

    const { product_page_id } = getState();

    const params = {
      resource_id,
      first_travel_date,
      passenger_types,
      extra_pick_ids,
      bed_requirement_id,
    };

    if (include_product_page_id) {
      params.product_page_id = product_page_id;
    }

    const firstStep = () =>
      discard_existing ? dispatch(discardBooking()) : Promise.resolve(true);

    return firstStep()
      .then(() => EcomEngineAPI.reservation.create(params))
      .then((json) => {
        dispatch(createReservationSucceeded(json));
        return json;
      })
      .catch((error) => {
        trackError(error);
        dispatch(createReservationFailure(error.message));
        return Promise.reject(error);
      });
  };

const createPackageReservationStarted = createAction(
  'reservation/createPackageReservationStarted'
);
const createPackageReservationSucceeded = createAction(
  'reservation/createPackageReservationSucceeded'
);
const createPackageReservationFailure = createAction(
  'reservation/createPackageReservationFailure'
);
const createPackageReservation = (payload) => (dispatch) => {
  dispatch(createPackageReservationStarted());

  const {
    resource_id,
    first_travel_date,
    passenger_types,
    suboptions,
    discard_existing = false,
    bed_requirement_id,
    selections,
  } = payload;

  const params = {
    product: {
      resource_id,
      first_travel_date,
      passenger_types,
      suboptions,
      bed_requirement_id,
    },
    selections,
  };

  const firstStep = () =>
    discard_existing ? dispatch(discardBooking()) : Promise.resolve(true);

  return firstStep()
    .then(() => EcomEngineAPI.reservation.packagesCreate(params))
    .then((json) => {
      dispatch(createPackageReservationSucceeded(json));
      return json;
    })
    .catch((error) => {
      trackError(error);
      dispatch(createPackageReservationFailure(error.message));
      return Promise.reject(error);
    });
};

export {
  createReservationStarted,
  createReservationSucceeded,
  createReservationFailure,
  createReservation,
  createPackageReservationStarted,
  createPackageReservationSucceeded,
  createPackageReservationFailure,
  createPackageReservation,
};
